import { ThirdPartyIntegrations } from "@/components/ThirdPartyIntegrations";

const IntegrationsPage = () => {
  return <ThirdPartyIntegrations />;
};

export default IntegrationsPage;